import {make_path,get_dirname} from './path_utils.js';
import {getSrcDir} from './src_dirs.js';
export function getBaseDir(): string {
    return get_dirname(getSrcDir());
}
export function getPublicDir():string {
    return make_path(getBaseDir(), 'public');
};
export function getDistDir():string {
    return make_path(getBaseDir(), 'dist');
};
export function getEnvDir():string {
    return make_path(getBaseDir(), '.env');
};